import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import React from "react";
import { cn } from "../lib/utils";

export interface SearchInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  /**
   * Optional custom class name for the input container
   */
  containerClassName?: string;
  /**
   * Optional custom class name for the icon
   */
  iconClassName?: string;
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      className,
      containerClassName,
      iconClassName,
      placeholder = "Search...",
      type = "text",
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn("relative", containerClassName)}>
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2">
          <MagnifyingGlassIcon
            className={cn("h-4 w-4 text-gray-400", iconClassName)}
            aria-hidden="true"
          />
        </div>
        <input
          type={type}
          className={cn(
            "block w-full rounded-md border border-gray-300 bg-white py-1.5 pl-8 pr-3 text-sm placeholder:text-gray-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500",
            className
          )}
          ref={ref}
          placeholder={placeholder}
          {...props}
        />
      </div>
    );
  }
);

SearchInput.displayName = "SearchInput";

export { SearchInput };
